import React from 'react'
import Icon from './'

const Menu = props => (
  <Icon {...props}>
    <path d="M1,14.78a3.45,3.45,0,0,1,3.44-3.45H59.56a3.45,3.45,0,0,1,0,6.89H4.44A3.44,3.44,0,0,1,1,14.78ZM1,32a3.44,3.44,0,0,1,3.44-3.44H59.56a3.44,3.44,0,0,1,0,6.88H4.44A3.44,3.44,0,0,1,1,32ZM1,49.22a3.44,3.44,0,0,1,3.44-3.44H59.56a3.45,3.45,0,0,1,0,6.89H4.44A3.45,3.45,0,0,1,1,49.22Z" />
  </Icon>
)

export default Menu
